<template>
    <div>
        <label :for="uuid" class="block mb-2 text-sm font-medium text-gray-900" v-if="label && label.length > 0">{{ label
        }}</label>
        <div class="relative">
            <label class="h-0 top-0 right-0 flex justify-end" :class="editorFocused ? 'sticky' : 'absolute'" style="z-index: 9999;">
                <ButtonPrimary @click="$refs.file.click()" class="h-10">
                    <UploadIcon />
                </ButtonPrimary>
            </label>
            <input ref="file" type="file" class="hidden" @change="fileUploaded" />
            <ckeditor :editor="editor" v-model="value" :config="editorConfig" @ready="editorReady" @focus="editorFocused = true" @blur="editorFocused = false"></ckeditor>
        </div>
        <div class="text-red-500" v-if="fielderrors && fielderrors[name]">
            {{ fielderrors[name] }}
        </div>
    </div>
</template>
<script>
const mediaSources = {
    description: [],
};

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from "@ckeditor/ckeditor5-vue";
import { useObjectUrl } from '@vueuse/core';
class CustomUploadAdapter {
    constructor(loader) {
        // The file loader instance to use during the upload. It sounds scary but do not
        // worry — the loader will be passed into the adapter later on in this guide.
        this.loader = loader;
    }

    upload() {
        return this.loader.file
            .then(file => new Promise((resolve) => {
                const data = useObjectUrl(file);
                mediaSources.description.push({
                    url: data.value,
                    type: file.type,
                    extension: file.name.split('.').pop(),
                });
                resolve({
                    default: data.value,
                });
            }));
    }
}

function CustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        // Configure the URL to the upload script in your back-end here!
        return new CustomUploadAdapter(loader);
    };
}

export default {
    components: {
        ckeditor: CKEditor.component
    },

    props: {
        name: {},
        label: {},
        type: {
            default: 'text',
        },
        placeholder: {
            default: '',
        },
        modelValue: {
            default: '',
        },
        fielderrors: {},

        mediaHandler: {},
    },

    mounted() {
        // this.editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
        //     return new CustomUploadAdapter( loader );
        // };
    },

    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                // uploadAdapter: CustomUploadAdapter,
                extraPlugins: [
                    CustomUploadAdapterPlugin,
                ],
                htmlSupport: {
                    allow: [{
                        name: /.*/,
                        attributes: true,
                        classes: true,
                        styles: true
                    }],
                }
            },
            ref: null,
            editorFocused: false,
            uuid: this.generateUUID(),
            value: this.modelValue,
        };
    },

    watch: {
        modelValue() {
            this.value = this.modelValue;
            console.log(this.value);
        },

        value() {
            this.changeValue(this.value);
            this.mediaHandler(mediaSources);
        }
    },

    methods: {
        changeValue(newValue) {
            this.$emit('update:modelValue', newValue);
        },

        editorReady(e) {
            this.ref = e;
        },

        insertHtml(html) {
            const viewFragment = this.ref.data.processor.toView(html);
            const modelFragment = this.ref.data.toModel(viewFragment);
            this.ref.model.insertContent(modelFragment);
        },

        fileUploaded(e) {
            const file = e.target.files[0];
            const data = useObjectUrl(file);
            mediaSources.description.push({
                url: data.value,
                type: file.type,
                extension: file.name.split('.').pop(),
            });

            const imageExtensions = ['jpg', 'jpeg', 'png', 'svg', 'gif', 'jfif', 'webp'];
            const videoExtensions = ['mp4', 'mov', 'wmv', 'avi', 'mkv'];

            const extension = file.name.split('.').pop();
            let html;
            if (imageExtensions.includes(extension)) {
                html = `<img src="${data.value}" />`;
            } else if (videoExtensions.includes(extension)) {
                html = `<video src="${data.value}" poster="" width="320" height="240" controls><source src="${data.value}" type="${file.type}">No video tag support</video>`;
            }

            console.log(html);

            if (html) {
                this.insertHtml(html);
            }

            this.$refs.file.value = null;
        }
    }
}
</script>